import { HeadingProperties } from '../components/heading/heading-types.js';
const ContextualBarProperties = {
    ...HeadingProperties,
};
export { ContextualBarProperties, };
//# sourceMappingURL=contextual-bar-types.js.map